import { Injectable } from '@angular/core';
import { CacheDuration } from '../constants/app.constant';
import { EncDecService } from 'src/app/core/utils/enc-dec.service';
import { InternalCacheService } from './internal-cache.service';

@Injectable({
  providedIn: 'root'
})
export class CacheResolverService extends EncDecService {
  /*********************Properties*********************/
  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(private readonly cache: InternalCacheService) {
    super();
  }
  /*********************Constructor*********************/

  /*********************Service Methods*********************/
  /**
   * Gets the value from cache if the key is provided.
   */
  get(key: string): any {
    
    try {
      const encryptedValue = this.cache.get(key);
      const decrypted = this.decrypt(encryptedValue);
      if (!encryptedValue) {
        return undefined;
      }
      return JSON.parse(decrypted) as any || undefined;
    } catch {
      return undefined;
    }
  }

  /**
   * Sets the value with key in the cache.
   */
  set(key: string, value: any, expiry?: number): boolean {

    try {
      expiry = expiry || CacheDuration.Default;
      const encryptedValue = this.encrypt(JSON.stringify(value));
      return this.cache.set(key, encryptedValue, expiry);
    } 
    catch {
      return false;
    }
  }

  /**
   * Checks if a key exists in cache
   */
  has(key: string): boolean {
    return this.get(key) !== undefined;
  }

  /**
   * Deletes the value from cache if the key is provided.
   */
  remove(key: string): void {
    this.cache.remove(key);
  }

  /**
   * Clears the cache.
   */
  clear(): void {
    this.cache.clear();
  }

  /*********************Service Methods*********************/
}
